export default __webpack_public_path__ + "static/media/colorPalette.3946b756.svg";